import { Button } from "@/components/ui/Button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/Card";
import { useNavigate } from "react-router-dom";
import { Camera, Sparkles, QrCode, ArrowRight } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col justify-between">
      {/* Header */}
      <header className="px-6 py-4 flex items-center justify-between border-b bg-white/80 backdrop-blur">
        <div className="flex items-center gap-2">
          <span className="text-xl">📸</span>
          <span className="font-bold text-lg text-slate-900">FotoMomen</span>
        </div>
        <Button size="sm" onClick={() => navigate("/dashboard")}>
          Masuk Dashboard
        </Button>
      </header>

      {/* Hero */}
      <main className="max-w-4xl mx-auto px-6 py-12 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-semibold mb-6">
          <Sparkles className="w-3.5 h-3.5" /> AI-Powered Event Photography Delivery
        </div>
        <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight mb-6">
          Check-in Tamu & Kirim Foto Otomatis ke WhatsApp
        </h1>
        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
          Tamu cukup selfie saat check-in. Fotografer upload folder ke Google Drive. Sistem langsung mencocokkan wajah dan mengirim foto ke WA tamu sebelum acara selesai!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Button size="lg" className="w-full sm:w-auto gap-2" onClick={() => navigate("/events/new")}>
            Buat Event Sekarang <ArrowRight className="w-4 h-4" />
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto" onClick={() => navigate("/checkin/demo-wedding")}>
            Coba Demo Check-in
          </Button>
        </div>

        {/* Feature Grid */}
        <div className="grid sm:grid-cols-3 gap-6 text-left">
          <Card>
            <CardHeader>
              <Camera className="w-8 h-8 text-blue-600 mb-2" />
              <CardTitle className="text-base">1. Check-in Selfie</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Tamu scan QR code di meja, isi nomor WA, dan ambil selfie instan via browser ponsel.
              </CardDescription>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Sparkles className="w-8 h-8 text-indigo-600 mb-2" />
              <CardTitle className="text-base">2. Face Match AI</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                AI memindai foto dari folder Google Drive fotografer dan mengenali wajah tamu secara akurat.
              </CardDescription>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <QrCode className="w-8 h-8 text-emerald-600 mb-2" />
              <CardTitle className="text-base">3. Instant WA Delivery</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Foto terkirim otomatis via WhatsApp Gateway ke masing-masing tamu sebelum mereka pulang.
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      </main>

      {/* Footer */}
      <footer className="text-center py-6 text-xs text-slate-400 border-t bg-white">
        &copy; {new Date().getFullYear()} FotoMomen SaaS. All rights reserved.
      </footer>
    </div>
  );
}